interface AppColorTheme {
  $PRIMARY_BACKGROUND: string
  $SECONDARY_BACKGROUND: string
}

const APP_COLOR_THEMES: Record<string, AppColorTheme> = {
  tea: {
    $PRIMARY_BACKGROUND: '#27352E',
    $SECONDARY_BACKGROUND: '#FFEEE1',
  },
  ge: {
    $PRIMARY_BACKGROUND: '#E78923',
    $SECONDARY_BACKGROUND: '#275E56',
  },
  'le-pain-quotidien': {
    $PRIMARY_BACKGROUND: '#FDC400',
    $SECONDARY_BACKGROUND: '#4E342E',
  },
  cs: {
    $PRIMARY_BACKGROUND: '#848624',
    $SECONDARY_BACKGROUND: '#18231d',
  },
  paru: {
    $PRIMARY_BACKGROUND: '#15182D',
    $SECONDARY_BACKGROUND: '#030B21',
  },
  jb: {
    $PRIMARY_BACKGROUND: '#080808',
    $SECONDARY_BACKGROUND: '#ebebe1',
  },
  ts: {
    $PRIMARY_BACKGROUND: '#50c9b5',
    $SECONDARY_BACKGROUND: '#b68356',
  },
  ronnie: {
    $PRIMARY_BACKGROUND: '#FCBF00',
    $SECONDARY_BACKGROUND: '#000000',
  },
  cm: {
    $PRIMARY_BACKGROUND: '#010101',
    $SECONDARY_BACKGROUND: '#E0E0E0',
  },
  vicolo: {
    $PRIMARY_BACKGROUND: '#919145',
    $SECONDARY_BACKGROUND: '#010101',
  },
  'signora-mariola': {
    $PRIMARY_BACKGROUND: '#1D1D1B',
    $SECONDARY_BACKGROUND: '#986E4C',
  },
  'acai-brasil': {
    $PRIMARY_BACKGROUND: '#5B1A34',
    $SECONDARY_BACKGROUND: '#F8F4EB',
  },
  'la-condesa': {
    $PRIMARY_BACKGROUND: '#1B5B75',
    $SECONDARY_BACKGROUND: '#F7EEDD',
  },
  'el-diez': {
    $PRIMARY_BACKGROUND: '#1B5B75',
    $SECONDARY_BACKGROUND: '#F8F4EB',
  },
}

const DEFAULT_APP_THEME: AppColorTheme = APP_COLOR_THEMES.ge

const APP_COLORS: AppColorTheme =
  APP_COLOR_THEMES[process.env.REACT_APP_NAME?.toLowerCase() || 'ge'] || DEFAULT_APP_THEME

export { APP_COLORS }
